export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '167ca5cd-4b07-4a11-b723-58ee03576a11';
export const MODAL_CLOSE_SEC = 2.5;
